<footer>
  <div class="container">
    <div class="row">
      <ul>
        <li>
          <a target="_blank" href="https://www.tt.com/datenschutz">Datenschutz &amp; Cookies</a>
        </li>
        <li>
          <a target="_blank" href="https://www.tt.com/impressum">Impressum</a>
        </li>
        <li>
          <a target="_blank" href="https://www.tt.com/kontakt">Kontakt</a>
        </li>
      </ul>
    </div>
  </div>
</footer>
